import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "@/utils/api";

// Async thunk for fetching user details (login)
export const fetchUser = createAsyncThunk(
    "user/fetchUser",
    async ({ email, password }, { rejectWithValue }) => {
        try {
            // Call the login API with email and password
            console.log("email:::", email, "\npassword:::", password);
            const response = await request({
                endpoint: "/user/login",
                method: "POST",
                body: { email, password },
            });

            console.log("response", response);

            // Check if the login was successful based on the response
            if (!response || response.success !== true) {
                return rejectWithValue(response.error.message || "Invalid credentials");
            }

            // Return the user data (including role and permissions)
            return response.data.user;
        } catch (error) {
            // Reject with a user-friendly error message
            console.log("error:::", error);
            return rejectWithValue(
                error.error.message || "An unexpected error occurred."
            );
        }
    }
);

// Async thunk for fetching user details (login)
export const logoutUser = createAsyncThunk(
    "user/logoutUser",
    async (_, { rejectWithValue }) => {
        try {
            const response = await request({
                endpoint: "/user/logout",
                method: "GET",
            });

            console.log("response", response);

            // Check if the login was successful based on the response
            if (!response || response.success !== true) {
                return rejectWithValue(
                    response.error.message || "Logout failed!! try again"
                );
            }

            localStorage.clear();

            // Return the user data (including role and permissions)
            return response.message;
        } catch (error) {
            // Reject with a user-friendly error message
            console.log("error:::", error);
            return rejectWithValue(
                error.error.message || "An unexpected error occurred."
            );
        }
    }
);

const initialState = {
    user: null, // User object containing details, role, and permissions
    loading: false,
    error: null,
};

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        addUser: (state, action) => {
            state.user = action.payload;
            state.loading = false;
            state.error = null;
        },
        clearUser: (state) => {
            state.user = null;
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUser.fulfilled, (state, action) => {
                state.loading = false;
                state.user = null; // Store the entire user object
            })
            .addCase(fetchUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Store the error message in the state
            })
            .addCase(logoutUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(logoutUser.fulfilled, (state, action) => {
                state.loading = false;
                state.user = null; // Store the entire user object
                state.error = null;
            })
            .addCase(logoutUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Store the error message in the state
            });
    },
});

export const { addUser, clearUser } = userSlice.actions;
export default userSlice.reducer;